import { createTheme } from "@mui/material/styles";
import { COLORS } from "@/config";

declare module "@mui/material/styles" {
    interface TypeText {
        green: string;
        mint: string;
    }
}

export const theme = createTheme({
    palette: {
        mode: "light",
        primary: {
            main: COLORS.green[400],
            light: COLORS.green[300],
            dark: COLORS.green[500],
        },
        background: {},
        text: {
            primary: COLORS.white,
            secondary: COLORS.gray[400],
            green: COLORS.green[200],
            mint: COLORS.mint[200],
        },
        grey: {
            50: COLORS.gray[50],
            100: COLORS.gray[100],
            200: COLORS.gray[200],
            300: COLORS.gray[300],
            400: COLORS.gray[400],
            500: COLORS.gray[500],
            600: COLORS.gray[600],
            700: COLORS.gray[700],
            800: COLORS.gray[800],
            900: COLORS.gray[900],
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    color: COLORS.black,
                    textTransform: "none",
                    borderRadius: "0.5rem",
                    "&.max-button": {
                        backgroundColor: COLORS.gray[900],
                        minWidth: "40px",
                        fontSize: "0.875rem",
                        "&:hover": {
                            backgroundColor: COLORS.gray[700],
                        },
                    },
                },
                contained: {
                    backgroundColor: COLORS.green[400],
                    "&:hover": {
                        backgroundColor: COLORS.green[500],
                    },
                    "&.Mui-disabled": {
                        backgroundColor: "rgba(32, 69, 49, 0.5)",
                    },
                },
                text: {
                    "&.MuiButton-textPrimary": {
                        color: COLORS.green[200],
                        "&:hover": {
                            backgroundColor: "transparent",
                            color: COLORS.green[100],
                        },
                    },
                },
            },
        },
        MuiSlider: {
            styleOverrides: {
                root: {
                    height: 42,
                },
                thumb: {
                    width: 32,
                    height: 32,
                    backgroundColor: COLORS.white,
                    "&:hover, &.Mui-focusVisible": {
                        boxShadow: "none",
                    },
                    "&::before": {
                        boxShadow: "none",
                    },
                    "&::after": {
                        boxShadow: "none",
                    },
                },
                track: {
                    backgroundColor: COLORS.green[400],
                    height: 32,
                    border: "none",
                    borderRadius: 8,
                },
                rail: {
                    backgroundColor: COLORS.gray[700],
                    height: 42,
                    borderRadius: 8,
                },
                mark: {
                    display: "none",
                },
            },
        },
    },
    typography: {
        allVariants: {
            fontFamily: "'Inter', sans-serif",
            color: COLORS.white,
        },
        h1: {
            color: COLORS.white,
        },
        h2: {
            color: COLORS.white,
        },
        h3: {
            color: COLORS.white,
        },
        h4: {
            color: COLORS.white,
        },
        h5: {
            color: COLORS.white,
        },
        subtitle1: {
            color: COLORS.gray[400],
        },
        subtitle2: {
            color: COLORS.gray[400],
        },
        body1: {
            color: COLORS.white,
        },
        body2: {
            color: COLORS.gray[400],
        },
    },
});
